export const COUNTERPARTY_SEARCH = 'src/Admin/Counterparty/Search/action/Counterparty_Search'
export const COUNTERPARTY_SEARCH_SUCCESS = 'src/Admin/Counterparty/Search/action/Counterparty_Search_Success'
export const COUNTERPARTY_SEARCH_FAILURE = 'src/Admin/Counterparty/Search/action/Counterparty_Search_Failure'
export const UPDATE_COUNTERPARTY_DATA = 'src/Admin/Counterparty/Search/action/Update_Counterparty_Data'
export const UPDATE_COUNTERPARTY_DATA_SUCCESS = 'src/Admin/Counterparty/Search/action/Update_Counterparty_Data_Success'
export const UPDATE_COUNTERPARTY_DATA_FAILURE = 'src/Admin/Counterparty/Search/action/Update_Counterparty_Data_Failure'
export const UPDATE_COUNTERPARTY_MASTER_DATA = 'src/Admin/Counterparty/Search/action/Update_Counterparty_Master_Data'
export const UPDATE_COUNTERPARTY_MASTER_DATA_SUCCESS = 'src/Admin/Counterparty/Search/action/Update_Counterparty_Master_Data_Success'
export const UPDATE_COUNTERPARTY_MASTER_DATA_FAILURE = 'src/Admin/Counterparty/Search/action/Update_Counterparty_Master_Data_Failure'

export const counterpartySearch = (data) => {
    return {
        type: COUNTERPARTY_SEARCH,
        data
    }
}
export const counterpartySearchSuccess = (data) => {
    return {
        type: COUNTERPARTY_SEARCH_SUCCESS,
        data
    }
}
export const counterpartySearchFailure = (data) => {
    return {
        type: COUNTERPARTY_SEARCH_FAILURE,
        data
    }
}

export const updateCounterpartyData = (data) => {
    return {
        type : UPDATE_COUNTERPARTY_DATA,
        data
    }
}

export const updateCounterpartyDataSuccess = (data) => {
    return {
        type : UPDATE_COUNTERPARTY_DATA_SUCCESS,
        data
    }
}

export const updateCounterpartyDataFailure = (error) => {
    return {
        type : UPDATE_COUNTERPARTY_DATA_FAILURE,
        error
    }
}

export const updateCounterpartyMasterData = (data) => {
    return {
        type : UPDATE_COUNTERPARTY_MASTER_DATA,
        data
    }
}

export const updateCounterpartyMasterDataSuccess = (data) => {
    return {
        type : UPDATE_COUNTERPARTY_MASTER_DATA_SUCCESS,
        data
    }
}

export const updateCounterpartyMasterDataFailure = (error) => {
    return {
        type : UPDATE_COUNTERPARTY_MASTER_DATA_FAILURE,
        error
    }
}